import React, { Fragment } from 'react';
import classNameBind from 'classnames/bind';
import Stack from '../Stack';
import styles from './styles.module.css';
import Step from './components/Step';

const bindClasses = classNameBind.bind(styles);
const STATUS_MAP = {
  '-1': 'finished',
  0: 'current',
  1: 'unfinished',
};

const ProgressStepper = ({ children, current, icons }) => (
  <div
    className={bindClasses('wrapper')}
    data-ppuc-id="ProgressStepper"
  >
    <Stack horizontalAlignment="middle" verticalAlignment="center" spacing="narrow">
      {React.Children.map(
        children,
        (child, mapIndex) => {
          const index = mapIndex + 1;
          const status = STATUS_MAP[Math.sign(mapIndex - current)];

          return (
            <Fragment>
              <Stack.Item>
                {React.cloneElement(
                  child,
                  { index, status, icon: child.props.icon || icons[status] },
                )}
              </Stack.Item>
              {index < children.length && (
                <Stack.Item fill>
                  <hr className={bindClasses('separator')} />
                </Stack.Item>
              )}
            </Fragment>
          );
        },
      )}
    </Stack>
  </div>
);

ProgressStepper.Step = Step;

ProgressStepper.defaultProps = {
  current: 0,
  icons: {
    finished: 'checkmark',
  },
};

export default ProgressStepper;
